/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const zh_hans1_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新`)
};

const zh_hant1_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新`)
};

const fr_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const ja_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新着`)
};

const ko_home_badge_new = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신규`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_badge_new = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_badge_new(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("home_badge_new", locale)
	if (locale === "en") return en_home_badge_new(inputs)
	if (locale === "zh-Hans") return zh_hans1_home_badge_new(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_badge_new(inputs)
	if (locale === "fr") return fr_home_badge_new(inputs)
	if (locale === "de") return de_home_badge_new(inputs)
	if (locale === "ja") return ja_home_badge_new(inputs)
	return ko_home_badge_new(inputs)
};